
    import { defineComponent } from 'vue';
    import truncate from 'vue-truncate-collapsed';
    //const API_USER = '/api/User';
    import AxiosService from '@/api-services/axios.service';
    import notify from '@/plugins/notify';
    import analytics, { gtagItemModel } from '@/plugins/analytics';
    import SubscriptionsBanner from './Banners/SubscriptionsBanner.vue';
    import GiftCardGirlBanner from './Banners/GiftCardGirlBanner.vue';
    import SellingPoints from './SellingPoints.vue';
    const API_MYPAGE = '/api/MyPage';
    const API_PARTNER = '/api/Partner';
    const API_SUBSCRIPTION = '/api/Subscription';

    export default defineComponent({
        created: function () {
            this.$store.state.showFooter = true;
        },
        data: function () {
            return {
                ready: false,
                PhotoUrl: "",
                PartnerName: "",
                CVR: "",
                HasActiveSquashSubscripton: null,
                PartnerDescription: "",
                ProductList: [],
                popoverOptions: {
                    popoverVariant: null,
                }
            }
        },
        watch: {
            '$store.state.ActiveLanguageId': function () {
                (<any>this).getPartnerInfo(this.$route.query.Id, this.$route.params.slug, this.$store.state.ActiveLanguageId);
            },
        },
        mounted() {
            (<any>this).getPartnerInfo(this.$route.query.Id, this.$route.params.slug, this.$store.state.ActiveLanguageId);
        },
        methods: {
            getPartnerInfo(partnerId, slug, languageId) {
                this.$data.ready = false;
                if (languageId) {
                    AxiosService.getMultiParams(API_PARTNER + '/getPartnerPageInfo', {
                        Id: partnerId,
                        Slug: slug,
                        LanguageId: languageId
                    }).then(response => {
                        this.$data.PhotoUrl = response.data.partnerInfo.PhotoUrl;
                        this.$data.PartnerName = response.data.partnerInfo.Name;
                        this.$data.CVR = response.data.partnerInfo.CVR;
                        this.$data.HasActiveSquashSubscripton = response.data.partnerInfo.HasActiveSquashSubscripton;
                        this.$data.PartnerDescription = response.data.partnerInfo.Description;
                        this.$data.ProductList = response.data.partnerProductListView;
                        analytics.trackViewItemList(
                            `${slug ? slug :"ID" + partnerId}`,
                            `PartnerName - ${this.$data.PartnerName}`,
                            [new gtagItemModel({ currency: "kr" })]
                        );
                        this.$data.ready = true;
                    }).catch(er => {
                        this.$router.push({ path: '/404' })
                    });
                }
            },
            // subscribe: function (product) {
            //     this.$data.ready = false;
            //     if (product.IsActiveSubscribe) {
            //         (<any>this).unSubscribe(product);
            //     } else {
            //         this.$router.push({ name: 'CheckOut', params: { productId: product.Id, frequency: this.$data.DeliveryFrequencyId, count: this.$data.Count } });
            //         // AxiosService.getMultiParams(API_MYPAGE + '/hasfulladdressandmoney', { price: product.Price })
            //         //     .then(response => {
            //         //         if (response.data) {
            //         //             AxiosService.create(API_SUBSCRIPTION + '/subscribe', {
            //         //                 DeliveryFrequencyId: this.$data.DeliveryFrequencyId,
            //         //                 ProductCategoryId: product.Id,
            //         //                 Quantity: this.$data.Quantity,
            //         //                 Comment: this.$data.Comment,
            //         //                 IsReceiveNewsletter: false,
            //         //                 OnCustomerAddress: true,
            //         //                 ReturnUrl: `${window.location.origin}/${this.$i18n.locale}${this.$t('Pages.OrderConfirm.path').toString()}`
            //         //             }).then(response => {
            //         //                 if (response.data.ReturnUrl) {
            //         //                     window.location.href = response.data.ReturnUrl;
            //         //                 };
            //         //                 if (response.data.PaymentStatus == "succeeded") {
            //         //                     analytics.trackPurchase([product.Id], product.Price, product.Currency);
            //         //                     this.$router.push({ name: 'OrderConfirm', params: { orderId: response.data.OrderId } });
            //         //                 };
            //         //                 this.$data.ready = true;
            //         //                 this.$root.$emit('bv::toggle::collapse', `accordion-${product.Id}`)
            //         //             }).catch(er => { notify.axiosError(er); this.$data.ready = true; });
            //         //         } else {
            //         //             this.$router.push({ name: 'CheckOut', params: { productId: product.Id, frequency: this.$data.DeliveryFrequencyId, count: this.$data.Count } });
            //         //         }
            //         //     }).catch(er => { notify.axiosError(er); this.$data.ready = true; });
            //     }
            // },
            unSubscribe: function (product) {
                this.$data.ready = false;
                AxiosService.post(API_SUBSCRIPTION + '/unsubscribe', { Id: product.SubscriptionId }
                ).then(response => {
                    analytics.trackUnsubscribe([product.Id], product.Price, product.Currency);
                    this.$router.push({ name: 'UnsubscribeConfirm', params: { productName: product.Name, plannedSubscriptionEndDate: response.data.PlannedSubscriptionEndDate } });
                    this.$data.ready = true;
                    this.$root?.$emit('bv::toggle::collapse', `accordion-${product.Id}`)
                }).catch(er => { notify.axiosError(er); this.$data.ready = true; });
            },
            // scrolltoAccordion(productId) {
            //     setTimeout((<any>this).scrollToElement(`accordion-${productId}`), 1000);
            // },
            // scrollToElement(elementId) {
            //     var element = document.getElementById(elementId);
            //     if (element) element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // },
            getRouterOptions(product) {
                return product.Slug ? { name: 'ProductPage', params: { slug: product.Slug } } : { name: 'ProductPage', params: { slug: (<any>this).$slugify(product.Name) }, query: { Id: product.Id } };
            },
            // openCollapse(product) {
            //     product.isPopoverVisible = !product.isPopoverVisible;
            //     this.$data.showOverlay = product.isPopoverVisible;
            // }
        },
        components: {
            truncate,
            SubscriptionsBanner,
            SellingPoints,
            GiftCardGirlBanner
        },
        computed: {
            BreadcrumbsItems() {
                return [
                    { "to": "/", "text": this.$t('general.brand-name') },
                    { "to": this.$t('Pages.PartnerPage.path').toString(), "text": this.$data.PartnerName || "" }
                ]
            }
        }
        
    })
